// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2Vu41","footer":"ModalFilter_footer__3cKd4"};